import React from "react";
import img1 from "./images/illustration/services-img-1.jpg";
import img2 from "./images/illustration/services-img-2.jpg";
import img3 from "./images/illustration/services-img-3.jpg";
import img4 from "./images/illustration/services-img-4.jpg";

const Best = () => {
  return (
    <>
      <section className="container-fluid " id="About">
        <section className="container">
          <section className="row  ">
            <div className="col-12">
              <h2 className="heading fw-bolder mb-4">OUR BEST CLASSES</h2>
              <p className="fw-bolder">
                Quisque velit sit viverra fermentum risus sed ac nisl. Eu risus
                tempus <br /> ultrices aliquam ornare eget tristique quisque.
                Aenean pla.
              </p>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-12 col-md-3 vishal">
                  <img src={img1} alt="image not found" className="w-100" />
                  <h6 className="fw-bolder">Stretching</h6>
                </div>
                <div className="col-12 col-md-3 vishal">
                  <img src={img2} alt="image not found" className="w-100" />
                  <h6 className="fw-bolder">Stretching</h6>
                </div>
                <div className="col-12 col-md-3 vishal">
                  <img src={img3} alt="image not found" className="w-100" />
                  <h6 className="fw-bolder">Stretching</h6>
                </div>
                <div className="col-12 col-md-3 vishal">
                  <img src={img4} alt="image not found" className="w-100" />
                  <h6 className="fw-bolder">Stretching</h6>
                </div>
              </div>
            </div>
          </section>
        </section>
      </section>
    </>
  );
};

export default Best;
